import React, { FC } from 'react';

import Button, { ButtonType, ButtonSize } from '@zvuk-b2b/react-uikit/ui/Button';

import { TEXTS } from './texts';

import styles from './index.module.scss';

type InvoiceActionsProps = {
  isPaymentByInvoiceRequested: boolean;
  isLoading: boolean;
  onPaymentByInvoiceRequest: () => Promise<void>;
};

const InvoiceActions: FC<InvoiceActionsProps> = ({
  isPaymentByInvoiceRequested,
  isLoading,
  onPaymentByInvoiceRequest,
}) => (
  <div className={styles.InvoiceActionsContainer}>
    <Button
      elementId="button_invoice_request"
      type={ButtonType.PRIMARY}
      size={ButtonSize.SMALL}
      isDisabled={isPaymentByInvoiceRequested}
      isLoading={isLoading}
      onClick={onPaymentByInvoiceRequest}
      className={styles.InvoiceActionsButton}>
      {isPaymentByInvoiceRequested ? TEXTS.INVOICE_REQUEST_BUTTON_DISABLED_TEXT : TEXTS.INVOICE_REQUEST_BUTTON_TEXT}
    </Button>
  </div>
);

export default React.memo(InvoiceActions);
